module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_4.d9c0e39d.png";